import { Checkbox, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper } from '@mui/material';
import { Theme } from '@mui/system';
import { stripHtmlAndConvertParagraphs } from '../../../../utils/common';
import { OnlyFansReleaseForms } from '../../../common/OnlyFansTagCreatorsSelector';

interface Props {
    sortedReleaseForms: OnlyFansReleaseForms.Item[];
    taggedReleaseForms: { id: number; name: string }[];
    handleListItemClicked: (id: number) => void;
    theme: Theme;
    disabled?: boolean;
    /** Ids rendered as an indeterminate (tri-state) checkbox, e.g. a form only some of the targets carry */
    indeterminateIds?: Set<number>;
}

const MessageUsersTagReleaseFormsList = (props: Props) => {
    const { sortedReleaseForms, taggedReleaseForms, handleListItemClicked, theme, disabled, indeterminateIds } = props;

    return (
        <Paper variant="outlined" sx={{ height: 200, overflow: 'auto', width: '100%', backgroundColor: 'transparent' }}>
            <List dense sx={{ width: '100%' }}>
                {sortedReleaseForms.map(list => {
                    const checked = taggedReleaseForms && taggedReleaseForms.find(item => item.id === list.id) ? true : false;
                    const indeterminate = !checked && !!indeterminateIds?.has(list.id);

                    return (
                        <ListItem
                            disablePadding
                            key={list.id}
                            sx={{
                                backgroundColor: checked ? theme.palette.grey[200] : indeterminate ? theme.palette.grey[100] : '',
                            }}
                        >
                            <ListItemButton
                                role={undefined}
                                dense
                                disableRipple={disabled}
                                disabled={
                                    disabled ||
                                    list.status === OnlyFansReleaseForms.Status.Declined ||
                                    list.status === OnlyFansReleaseForms.Status.Failed
                                }
                                onClick={() => {
                                    if (!disabled) {
                                        handleListItemClicked(list.id);
                                    }
                                }}
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        tabIndex={-1}
                                        disableRipple
                                        checked={checked}
                                        indeterminate={indeterminate}
                                        disabled={disabled}
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    primary={stripHtmlAndConvertParagraphs(list.name)}
                                    secondary={`Status: ${list.status} | Type: ${list.type}`}
                                />
                            </ListItemButton>
                        </ListItem>
                    );
                })}
            </List>
        </Paper>
    );
};

export default MessageUsersTagReleaseFormsList;
